export default __webpack_public_path__ + "static/media/view-calendar.797f8bed.svg";